import { createFileRoute } from "@tanstack/react-router";
import { ApplyPage } from "@/features/apply/ApplyPage";

/** Public application form for one job (A6d-COMMS3). Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/apply/$job")({
  component: ApplyRoute,
});

function ApplyRoute() {
  const { job } = Route.useParams();
  return <ApplyPage job={job} />;
}
